<template>
    <!-- Start combobox + expansion panel for events grid filter -->    
  <div class="combobox-group neumorphism-in">

    <div>{{ $t("filters.eventTitle") }}</div>

    <!-- Start Menu Cities -->
    <v-autocomplete
      v-model="eventsMultiArray.city"
      :items="locations"
      chips
      clearable
      :label="$t('filters.citiesFilter')" 
      item-text="city"
      item-value="city"
      color="red"
      @input="filterCityOption"
    >
      <!-- Start tags Cities -->
      <template v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          @click="data.select"
        >
          <v-icon
            left
            :color="data.item.color"
          >
            mdi-circle
          </v-icon>
          {{ data.item.city }}
        </v-chip>
      </template>
      <!-- End tags Cities -->
      <!-- Start list Cities -->
      <template v-slot:item="data">
        <template>
          <v-list-item-avatar>
            <v-icon
            left
            :color="data.item.color"
          >
            mdi-circle
          </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ data.item.city }}</v-list-item-title>
          </v-list-item-content>
        </template>
      </template>
      <!-- End list Cities -->
    </v-autocomplete>
    <!-- End Menu Cities -->
    <!-- Start Menu courses -->
    <v-autocomplete
      v-model="eventsMultiArray.course"
      :items="courses"
      chips
      clearable
      :label="$t('filters.course')" 
      item-text="title"
      item-value="id"
      color="red"
      @input="filterCityOption"
    >
      <!-- Start tags courses -->
      <template v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          @click="data.select"
        >
          {{ data.item.title }}
        </v-chip>
      </template>
      <!-- End tags courses -->
      <!-- Start list courses -->
      <template v-slot:item="data">
        <template>
          <v-list-item-content>
            <v-list-item-title>{{ data.item.title }}</v-list-item-title>
          </v-list-item-content>
        </template>
      </template>
      <!-- End list courses -->
    </v-autocomplete>
    <!-- End Menu courses -->



    <div>
      <!-- Start Menu Options -->
      <v-autocomplete
        v-model="eventsMultiArray.option"
        :items="$enumInterventionStatus"
        item-text="text"
        item-value="value"
        :label="$t('filters.optionsFilter')"  
        @input="filterCityOption"
        clearable
        color="red"
      >
        <!-- Start tags Options -->
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0">
            <span>{{ item.text }}</span>
          </v-chip>
          <span v-if="index === 1" class="grey--text caption">
            (+{{ eventsMultiArray.option.length - 1 }} {{ $t("filters.others") }})
          </span>
        </template>
        <!-- End tags Options -->
      </v-autocomplete>
      <!-- End Menu Options -->
    </div>

    <div>
      <!-- Start Menu Validated -->
      <v-autocomplete
        v-model="eventsMultiArray.validated"
        :items="confirm"
        item-text="text"
        item-value="value"
        :label="$t('filters.confirmFilter')"  
        @input="filterCityOption"
        clearable
        color="red"
      >
        <!-- Start tags Validated -->
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0">
            <span>{{ item.text }}</span>
          </v-chip>
          <span v-if="index === 1" class="grey--text caption">
            (+{{ eventsMultiArray.validated.length - 1 }} {{ $t("filters.others") }})
          </span>
        </template>
        <!-- End tags Validated -->
      </v-autocomplete>
      <!-- End Menu Validated -->
    </div>

  </div>
  <!-- End combobox + expansion panel for events grid filter -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: [],
  data() {
    return {
      confirm: [{ text: this.$t("filters.confirmTrue"), value: true },
                { text: this.$t("filters.confirmFalse"), value: false },]
    };
  },
  computed: {
    ...mapGetters("locationModule", { locations: "getLocations" }),
    ...mapGetters("courseModule", { courses: "getCourses" }),
    ...mapGetters("eventModule", {
      events: "getEvents",
      eventsMultiArray: "getEventsMultiarray",
    }),
  },
  watch: {
    events: function() {
      this.filterCityOption();
    },
  },
  mounted() {},
  methods: {
    // ...mapActions("eventModule", ["updateEventsMultiarray"]),
  /**
   * This method will filter events in the planning.
   * Parameters selected by the client are in the object eventsMultiArray: { city: null, option: null, validated: null }
   */
    filterCityOption() { 
      this.events.forEach((e) => {
          e.display = ((e.location === this.eventsMultiArray.city || this.eventsMultiArray.city === null)
                        && (e.details.type === this.eventsMultiArray.option || this.eventsMultiArray.option === null)
                        && (e.details.validated === this.eventsMultiArray.validated || this.eventsMultiArray.validated === null)
                        && (e.details.course.id === this.eventsMultiArray.course || this.eventsMultiArray.course === null)
                        ) ? true : false;
      });
    },
  },
};
</script>

<style>
.combobox-group {
  padding: 20px;
  border-radius: 20px;
}
</style>
